<template>
  <div id="app">
    <div class="wrapper">
      <Header
        v-if="user"
        :style="'padding-left: 20%; padding-right: 20%; margin-left: 0 !important'"
      />
      <loading
        :active.sync="$wait.any"
        :can-cancel="false"
        :is-full-page="true"
      />
      <!--<Sidebar v-if="user" />-->
      <router-view class="main-font-style" />
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// import SysUtils from '@/base/utils/SysUtils'
import Header from '@/components/organisms/OrHeader'
// import Sidebar from '@/components/organisms/OrSidebar'

export default {
  name: 'App',
  components: {
    Header,
    Loading
    // Sidebar
  },
  data () {
    let userToken = localStorage.getItem('fs_token')
    let userId = localStorage.getItem('fs_user_id')
    return {
      user_token: userToken,
      user_id: userId
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user) {
        return true
      }
      return false
    }
  },
  beforeCreate () {
    window.toasted = this.$toasted
    window.wait = this.$wait
  }
}
</script>

<style>
label:not(.form-check-label):not(.custom-file-label) {
  line-height: normal !important;
}
.custom-control.custom-checkbox .custom-control-label,
.custom-control.custom-radio .custom-control-label,
.custom-control.custom-control-inline.custom-radio .custom-control-label,
.custom-control.custom-control-inline.custom-checkbox .custom-control-label {
  padding-left: 1.5em !important;
}

.modal-xl {
  max-width: 1140px !important;
}

.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}
span.badge {
  line-height: normal !important;
}
</style>
